export enum PropertyImageType { 
        PropertyImageThumbnail = 0,
        PropertyImageWeb = 1,
        PropertyImageHighRes = 2,
}

